<template>
  <div class="main-container page-container">
    <Tabs v-model="tab" :animated="false" v-if="$units.superviseShowVal()">
      <TabPane label="保司协议" name="insuranceCompany"></TabPane>
      <TabPane label="通道协议" name="channel"></TabPane>
    </Tabs>
    <keep-alive>
      <insuranceCompany v-if="tab == 'insuranceCompany'"></insuranceCompany>
      <channel v-if="tab == 'channel'"></channel>
    </keep-alive>
  </div>
</template>

<script>
import insuranceCompany from './components/insuranceCompany';
import channel from './components/channel';

export default {
  components: {
    insuranceCompany,
    channel
  },
  data() {
    return {
      tab: 'insuranceCompany',
      tabList: [
        {
          label: '保司协议',
          components: 'insuranceCompany'
        },
        {
          label: '通道协议',
          components: 'channel'
        }
      ]
    };
  },
  mounted() {
    if (this.$route.query.tab) {
      this.tab = this.$route.query.tab;
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.page-container {
  position: relative;
  /deep/ .ivu-tabs-tab {
    padding-top: 0 !important;
    font-size: 14px;
  }
  /deep/ {
    .ivu-tabs-bar {
      border-bottom: 1px solid #ececec;
    }
    .ivu-tabs-ink-bar {
      display: none;
    }
    .ivu-tabs-tab {
      padding: 9px 0 10px;
      margin-right: 44px;
      font-size: 14px;
      color: #515c6f;
    }
    .ivu-tabs-tab-active {
      position: relative;
      color: #236dff;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 1px;
        height: 2px;
        width: 100%;
        background-color: #236dff;
      }
    }
  }
}
</style>
